// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".min-height-modal{min-height:20rem}.line-vertical{border-left:1px solid #e9ecef;margin:0 10px}.line-horizontal{border-bottom:1px solid #e9ecef;margin:14px 0}", ""]);
// Exports
module.exports = exports;
